import React, { useState, useEffect } from "react";
import Axios from "../../constants/api_management/MyHttpHelperWithToken";
import CartItem from "../../Components/Cart/CartItem";
import "./Cart.css";

const CartView = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checkoutUrl, setCheckoutUrl] = useState("");
  const [alert, setAlert] = useState(null); // ✅ Alert state

  // Auto-dismiss alert
  useEffect(() => {
    if (alert) {
      const timeout = setTimeout(() => setAlert(null), 4000);
      return () => clearTimeout(timeout);
    }
  }, [alert]);

  // console.log("33", cartItems);
  // Fetch cart data from the backend
  const fetchCartData = async () => {
    try {
      const response = await Axios.get(`/cart`);
      // Extract cart items and subtotal from response data
      const { items } = response.data.data.data;
      // console.log("a", response);
      setCartItems(items);
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };

  useEffect(() => {
    fetchCartData();
  }, []);

  // Delete item from the cart
  const handleDeleteItem = async (itemId) => {
    try {
      const response = await Axios.delete(`/cart`, {
        data: { product: itemId },
      });

      if (response?.data?.status === "success") {
        setAlert({ type: "success", message: "Item removed from cart" });
        fetchCartData();
      } else {
        setAlert({ type: "error", message: "Failed to delete item" });
      }

      // Update local state
      setCartItems((prevItems) =>
        prevItems.filter((item) => item._id !== itemId)
      );
    } catch (error) {
      console.error("Error deleting item:", error);
      setAlert({
        type: "error",
        message: "An error occurred while deleting item",
      });
    }
  };

  // Checkout function (you can implement as needed)

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const itemIds = cartItems.map((item) => item._id);
      const paymentOption = "gateway";

      const response = await Axios.put("/cart/checkout", {
        items: itemIds,
        payment_option: paymentOption,
        path: "/success-page",
      });
      const responseUrl = response?.data?.data?.checkoutUrl?.authorization_url;
      if (responseUrl) {
        setAlert({ type: "success", message: "Checkout initialized" });
        setCheckoutUrl(responseUrl);
      } else {
        setAlert({ type: "error", message: "Checkout failed" });
      }

      // setCartItems([]);
    } catch (error) {
      const msg = error?.response?.data?.message || "Checkout failed";
      setAlert({ type: "error", message: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cart-view">
      <h2>Your Cart</h2>
      {alert && (
        <div className={`alert-fixed ${alert.type}`}>
          {alert.message}
          <button onClick={() => setAlert(null)}>×</button>
        </div>
      )}
      {checkoutUrl ? (
        <div className="checkout-url">
          <p>Your order has been successfully placed!</p>
          <p>
            Proceed to payment:{" "}
            <a
              className="checkout-link"
              href={checkoutUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here
            </a>
          </p>
        </div>
      ) : cartItems.length === 0 ? (
        <p>Your Shopping Cart is Empty</p>
      ) : (
        <>
          {cartItems.map((item) => (
            <CartItem
              key={item.id}
              item={item}
              onDelete={() => handleDeleteItem(item?.product?._id)}
            />
          ))}
          <div className="button-cont">
            <button
              className="checkout-btn"
              onClick={handleCheckout}
              disabled={loading}
            >
              {loading ? "Processing..." : "Checkout"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CartView;
